import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

// Auto-refresh the access token on 401, then retry the original request once.
let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;
    const status = error.response?.status;
    const url = original?.url || "";
    const isAuthCall = /\/auth\/(login|refresh|logout)/.test(url);
    if (status === 401 && original && !original._retry && !isAuthCall) {
      original._retry = true;
      try {
        if (!refreshing) refreshing = api.post("/auth/refresh").finally(() => { refreshing = null; });
        await refreshing;
        return api(original);
      } catch (e) {
        const p = typeof window !== "undefined" ? window.location.pathname : "";
        if (p && !p.startsWith("/login") && !p.startsWith("/store")) {
          window.location.href = "/login";
        }
        return Promise.reject(e);
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function paymentLabel(m) {
  const map = { card: "Credit Card", credit_card: "Credit Card", cash: "Cash", cheque: "Cheque", e_transfer: "e-Transfer", wallet: "Wallet", bank_transfer: "Bank Transfer", unpaid: "Unpaid", apple_pay: "Apple Pay", google_pay: "Google Pay" };
  return map[m] || (m || "").replace(/_/g, " ");
}

export default api;
